import React, { useRef, useState } from 'react';
import { usePapaParse } from 'react-papaparse';
import S from './SensorDataTab.module.scss';

const toNumber = (value) => {
  if (value === '' || value === null || value === undefined) return null;
  const parsed = Number(String(value).replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
};

const buildPayload = (rows) => ({
  sensors_data: rows.reduce((acc, row) => {
    const sensorId = toNumber(row.sensor_id);
    const pkTest = toNumber(row.pk_test);
    if (sensorId === null || pkTest === null) return acc;

    if (!Array.isArray(acc[sensorId])) acc[sensorId] = [];
    acc[sensorId].push({
      pk_test: pkTest,
      time_unix: toNumber(row.time_unix),
      value: toNumber(row.value),
      calc_value: toNumber(row.calc_value),
    });
    return acc;
  }, {}),
});

const SensorImportTab = () => {
  const { readString } = usePapaParse();
  const inputRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [previewRows, setPreviewRows] = useState([]);
  const [error, setError] = useState('');

  const handleFile = (file) => {
    if (!file) return;
    setFileName(file.name);
    setError('');

    const reader = new FileReader();
    reader.onload = (event) => {
      readString(String(event.target.result || ''), {
        header: true,
        delimiter: ';',
        skipEmptyLines: true,
        complete: ({ data }) => {
          const rows = (data || []).filter(
            (row) => row && Object.keys(row).length
          );
          const payload = buildPayload(rows);
          console.log('[SensorImportTab] parsed import payload:', payload);
          setPreviewRows(rows);
          if (!Object.keys(payload.sensors_data).length) {
            setError('CSV invalide ou vide.');
          }
        },
        error: () => setError('Impossible de lire le CSV.'),
      });
    };
    reader.readAsText(file, 'UTF-8');
  };

  return (
    <div className={S.importSection}>
      <div className={S.dropZone} onClick={() => inputRef.current?.click()}>
        <div className={S.dropIcon}>📂</div>
        <div className={S.dropLabel}>Importer un CSV</div>
        <p>Format attendu: sensor_id;pk_test;time_unix;value;calc_value</p>
        <input
          ref={inputRef}
          type="file"
          accept=".csv"
          className={S.fileInput}
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
      </div>

      {fileName && <div className={S.formatInfo}>{fileName}</div>}
      {error && <div className={S.alertErreur}>{error}</div>}
      {previewRows.length > 0 && (
        <div className={S.formatInfo}>
          {previewRows.length} ligne(s) parsée(s)
        </div>
      )}
    </div>
  );
};

export default SensorImportTab;
